import { Box, TableCell, TableRow, Theme, Typography, useTheme } from "@mui/material";
import { useHistory } from "react-router";
import { ColorMap, TableBodyData } from "../../types";
import { checkImageExists, formatCurrency, toINR } from "../../../../utils/utilityFunctions";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../../redux-store/reducers";

const colorMap: ColorMap = {
    profit: "success.500",
    loss: "error.500"
}

export const Top10BondsHoldingBody = (
    {
        tableBodyData,
        handleCheckboxClick,
        clientCode
    }: any
): JSX.Element => {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const theme = useTheme();
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {

                const folioCheck = obj?.folioNo !== '0' ? `(${obj?.folioNo})` : ''

                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    fontSize: '16px',
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                })}
                            >
                                {obj?.schemeName ? `${obj?.schemeName}${folioCheck}` : '-'}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.investedValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.investedValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.investedValue ?? 0, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.amount < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.amount ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.amount ?? 0, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.return >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.return && (obj?.return).toFixed(2)}%
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.investedOn}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.periodOfInvestment}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}

export const Top10BondsBody = (
    {
        tableBodyData,
        handleCheckboxClick,
        clientCode
    }: any
): JSX.Element => {
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    const theme = useTheme();
    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                    ':hover': {
                                        cursor: 'pointer',
                                        color: theme.palette.primary[500]
                                    }
                                })}
                            >
                                {obj?.schemeName}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.amount < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.amount ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.amount ?? 0, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>

                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.return >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {!Number.isNaN(Number(obj?.return ?? 0)) ?
                                    Math.round(Number(obj?.return ?? 0) * 100) / 100 : '0'}%
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {!Number.isNaN(Number(obj?.expenseRatio ?? 0)) ?
                                    Math.round(Number(obj?.expenseRatio ?? 0) * 100) / 100 : '0'}%
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}

export const BondsQuantativeBody = (
    {
        tableBodyData,
        handleCheckboxClick,
        clientCode
    }: any
): JSX.Element => {
    const theme = useTheme();

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        {(obj?.amcname !== "P/E" && obj?.amcname !== "P/B") && <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                    ':hover': {
                                        cursor: 'pointer',
                                        color: theme.palette.primary[500]
                                    }
                                })}
                            >
                                {obj?.amcname}
                            </Typography>
                        </TableCell>}
                        {(obj?.amcname !== "P/E" && obj?.amcname !== "P/B") && <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {!Number.isNaN(Number(obj?.holding ?? 0)) ?
                                    Math.round((obj?.holding ?? 0) * 100) / 100 : '0'}
                            </Typography>
                        </TableCell>}
                    </TableRow>
                )
            })}
        </>
    )
}

export const HoldingDetailsBody = (
    {
        tableBodyData,
        handleCheckboxClick,
        clientCode
    }: any
): JSX.Element => {
    const theme = useTheme();

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    // const formatCurrency = (amount: number) => {
    //     return amount.toFixed(2);
    // };


    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {

                const amount = obj?.percentage?.amount ?? 0;
                const formattedAmount = formatCurrency({ value: Math.abs(amount), locale, currencyCode });
                const sign = amount < 0 ? '-' : '';
                const percentage = !Number.isNaN(Number(obj?.percentage?.percentage ?? 0)) ? Math.round((obj?.percentage?.percentage ?? 0) * 100) / 100 : 0;

                const gainLoss = `${sign}${formattedAmount}(${percentage}%)`;

                const folioCheck = obj?.folioNo !== '0' ? `(${obj?.folioNo})` : ''

                const amcIds = ['BDOTR', 'BPIAMC']

                const checkAmcId = amcIds.includes(obj?.amcId ?? '') ? obj?.amcId?.toLowerCase() : obj?.amcId;

                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <img src={checkImageExists(`${checkAmcId}`) ? `../../../../../../images/amcIcons/${checkAmcId}.svg` : `../../../../../../images/amcIcons/default.svg`} width={'50px'} height={'50px'} alt={obj?.schemeName} style={{ borderRadius: '8px 8px 8px 8px' }} />
                                <Box>
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            fontSize: '16px',
                                            color: theme.palette.text.primary,
                                            '&:hover': {
                                                color: theme.palette.primary[500]
                                            },
                                        })}
                                    >
                                        {obj?.schemeName ? `${obj?.schemeName}${folioCheck}` : '-'}
                                    </Typography>
                                </Box>
                            </Box>
                        </TableCell>
                        {/* <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.categoryName}
                            </Typography>
                        </TableCell> */}
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.investedValue < 0 ? `- ${formatCurrency({ value: obj?.investedValue ?? 0, locale, currencyCode })}` : `${formatCurrency({ value: obj?.investedValue ?? 0, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.marketValue < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.marketValue ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.marketValue ?? 0, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    color: obj?.percentage?.amount >= 0 ? colorMap["profit"] : colorMap["loss"],
                                    fontSize: '16px',
                                }}
                            >
                                {gainLoss}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}

export const TransactionDetailsBody = (
    {
        tableBodyData,
        handleCheckboxClick,
        clientCode
    }: any
): JSX.Element => {
    const theme = useTheme();

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, i: number) => {
                return (
                    <TableRow
                        key={i}
                        sx={{
                            '& td': {
                                paddingTop: "20px",
                                paddingBottom: "15px",
                                borderBottom: `0.5px solid ${theme.palette.text.secondary}B2`,
                                ':first-of-type': {
                                    paddingLeft: "0px",
                                }
                            },
                        }}
                    >
                        <TableCell align="left">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                    ':hover': {
                                        cursor: 'pointer',
                                        color: theme.palette.primary[500]
                                    }
                                })}
                            >
                                {obj?.scheme}
                            </Typography>

                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.schemeCategory}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.transactionAmount < 0 ? `- ${formatCurrency({ value: Math.abs(obj?.transactionAmount ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: obj?.transactionAmount ?? 0, locale, currencyCode })}`}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    fontSize: '16px',
                                })}
                            >
                                {obj?.transactionType}
                            </Typography>
                        </TableCell>
                        <TableCell align="center">
                            <Typography
                                variant="body_500"
                                sx={{
                                    fontSize: '16px',
                                }}
                            >
                                {obj?.transactionDate}
                            </Typography>
                        </TableCell>
                    </TableRow>
                )
            })}
        </>
    )
}

